var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tnc-box" },
    [
      _c(
        "div",
        { staticClass: "tnc-box__title-bar" },
        [
          _c(
            "a-row",
            {
              attrs: {
                align: "middle",
                type: "flex",
                justify: "space-between",
              },
            },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c("HKLGrayHintVue", [
                    _vm._v(
                      "\n          " + _vm._s(_vm.lastUpdatedBy) + "\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _vm.canEdit
                ? _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-row",
                        {
                          staticClass: "tnc-box__buttons",
                          attrs: { type: "flex", justify: "end" },
                        },
                        [
                          !_vm.isEditing
                            ? _c("HKLUploadButton", {
                                on: { importFile: _vm.importJson },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isEditing
                            ? _c("HKLButton", {
                                attrs: { color: "orange", action: "export" },
                                on: { click: _vm.exportJson },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isEditing
                            ? _c("HKLButton", {
                                attrs: { color: "orange", action: "edit" },
                                on: { click: _vm.edit },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditing
                            ? _c("HKLButton", {
                                attrs: { color: "darkblue", action: "cancel" },
                                on: { click: _vm.cancel },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isEditing
                            ? _c("HKLButton", {
                                attrs: { color: "orange", action: "save" },
                                on: { click: _vm.save },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("CommonTNC", {
        ref: "commonTNCRef",
        staticClass: "tnc-box__collapse",
      }),
      _vm._v(" "),
      _c("TenancyRecordTNC", {
        ref: "trTNCRef",
        staticClass: "tnc-box__collapse",
      }),
      _vm._v(" "),
      _c("HotbTNC", { ref: "hotbTNCRef", staticClass: "tnc-box__collapse" }),
      _vm._v(" "),
      _c("TenantProjectTNC", {
        ref: "tpTNCRef",
        staticClass: "tnc-box__collapse",
      }),
      _vm._v(" "),
      _c("DirectoryTNC", {
        ref: "directoryTNCRef",
        staticClass: "tnc-box__collapse",
      }),
      _vm._v(" "),
      _c("WorkPermitTNC", {
        ref: "wpTNCRef",
        staticClass: "tnc-box__collapse",
      }),
      _vm._v(" "),
      _c("ItqTenderTNC", {
        ref: "tenderTNCRef",
        staticClass: "tnc-box__collapse",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }